import { jsx as _jsx } from "react/jsx-runtime";
import { Popup } from "semantic-ui-react";
const SHOW_ISCR_TENANT_ICON = false;
export const isPriceline = (tenant) => /^priceline/i.test(tenant !== null && tenant !== void 0 ? tenant : "");
function PricelineIcon() {
    return (_jsx(Popup, { trigger: _jsx("img", { src: "https://storage.googleapis.com/instant-med-public/icons/priceline.svg", alt: "Priceline", className: "w-6 h-6" }), content: "Priceline" }));
}
function InstantScriptsIcon() {
    return (_jsx(Popup, { trigger: _jsx("img", { src: "/images/v2/home/heart-single.png", alt: "InstantScripts", className: "w-8 h-8" }), content: "InstantScripts" }));
}
export function TenantIcon({ tenant }) {
    if (isPriceline(tenant)) {
        return _jsx(PricelineIcon, {});
    }
    if (SHOW_ISCR_TENANT_ICON) {
        return _jsx(InstantScriptsIcon, {});
    }
    return null;
}
